import type {
  FoundationSuperType,
  FoundationSubType,
  FoundationSuperSystemType,
  FoundationSubSystemType,
} from "building-types/foundations/foundationEnums";
import type {
  FoundationSettingsConfig,
  FoundationSystemSettings,
} from "building-types/settings/foundationSettingsTypes";
import { assertIsNotNullOrUndefined } from "common/utils/assertOfType";
import { foundationSubSystemTypes } from "doc/utils/foundationSystemTools";

export function foundationSystemSettingsFromSettingsConfig<
  S extends FoundationSuperType,
  T extends FoundationSubType<S>,
>(settingsConfig: FoundationSettingsConfig<S, T>): FoundationSystemSettings {
  const res = settingsConfig[settingsConfig.foundationHash];
  assertIsNotNullOrUndefined(res);
  return res as FoundationSystemSettings;
}

export function isValidFoundationHash(hash: string) {
  const split = hash.split(".");
  const [superType, subType] = split as [FoundationSuperSystemType, FoundationSubSystemType];
  return split.length === 2 && foundationSubSystemTypes(superType).includes(subType);
}

export function extractFoundationSystemTypesFromHash(
  hash: string,
): [FoundationSuperSystemType, FoundationSubSystemType] | null {
  const split = hash.split(".");
  const [superType, subType] = split as [FoundationSuperSystemType, FoundationSubSystemType];
  if (split.length === 2 && foundationSubSystemTypes(superType).includes(subType)) {
    return [superType, subType];
  } else {
    return null;
  }
}
